import type { SVGProps } from "react";

const HeroShapes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={453}
    height={223}
    viewBox="0 0 453 223"
    fill="none"
    {...props}
  >
    <path d="M444.58 186.67L378.02 148.25L311.48 186.67V222.71H444.58V186.67Z" fill="#214EFF" />
    <path d="M68.1799 157.04C31.3899 157.04 1.43994 186.23 0.189941 222.72H45.6199C46.8099 211.31 56.4499 202.41 68.1799 202.41C79.9099 202.41 89.5499 211.31 90.7399 222.72H136.17C134.92 186.24 104.97 157.04 68.1799 157.04V157.04Z" fill="#6B22C4" />
    <path d="M295.29 222.71V157.79L230.36 222.71H295.29Z" fill="#B0813D" />
    <path d="M295.29 157.79H160.69V222.71H230.36L295.29 157.79Z" fill="#D9A04C" />
    <path fillRule="evenodd" clipRule="evenodd" d="M0 20.6699V157.04L136.37 20.6699H0Z" fill="#D9A04C" />
    <path d="M228.27 139.3C265.588 139.3 295.84 109.048 295.84 71.7301C295.84 34.4123 265.588 4.16016 228.27 4.16016C190.952 4.16016 160.7 34.4123 160.7 71.7301C160.7 109.048 190.952 139.3 228.27 139.3Z" fill="#0038D6" />
    <path d="M380.94 0C341.32 0 309.21 32.11 309.21 71.73H452.67C452.67 32.12 420.55 0 380.94 0V0Z" fill="#F70F3D" />
    <path d="M309.21 143.46H452.67C452.67 103.84 420.55 71.7297 380.94 71.7297C341.33 71.7297 309.21 103.85 309.21 143.46Z" fill="#D6002B" />
    <path d="M126.58 96.5493L115.521 107.608L126.58 118.668L137.639 107.608L126.58 96.5493Z" fill="#B0813D" />
    <path d="M88.4127 96.5267L77.3535 107.586L88.4127 118.645L99.4718 107.586L88.4127 96.5267Z" fill="#D9A04C" />
  </svg>
);

export default HeroShapes;